let controller = function (
	$scope, 
	$stateParams, 
	$state, 
	$filter, 
	$rootScope,
	$ionicHistory,
	$ionicViewSwitcher,
	Filter, 
	Category,
	Compare,
	Definition,
	Process,
	$ionicLoading,
	$q,
	$ionicNavBarDelegate
) {
	'ngInject'

	var vm = this;
	var backView = $ionicHistory.backView();
	vm.hasHistory = backView;
	
	function initialize() {

		$ionicLoading.show();

		$q.all([
			Category.get(Filter.getActive('categories')),
			Filter.get({categories:Filter.getActive('categories')})
		]).then(function(res) {
			vm.data = res[0];
			vm.title = $filter('translate')('category_title').replace('%s', vm.data.singular);
			vm.filters = res[1];
			Filter.loadInterface(vm.filters);
		}).catch(function(err) {
			console.log(err);
		}).finally(function() {
			$ionicLoading.hide();
		});
	}
	

	vm.back = function() {
		$ionicViewSwitcher.nextDirection('back');
		$ionicHistory.nextViewOptions({
			disableBack: true,
		    historyRoot: true
		});
		vm.hasHistory = true;
		$state.go('tab.search');
	}

	vm.toggle = {
		definition: function(definition) {
			Filter.toggle.definition(definition);
			Filter.change();
		}
	}

	vm.toSearch = function() {
		$ionicHistory.nextViewOptions({
			historyRoot: true,
			disableBack: true
		});
		$state.go('tab.search');
	}

	vm.startProcess = function() {
		Process.create({
			category_id: vm.data.id,
			price: Filter.getActive('price'),
			definitions: Filter.getActive('definitions'),
			filters: Filter.getActive('filters'),
			brands: Filter.getActive('brands'),
			skey: Filter.getActive('skey')
		}).then(function(res) {
			Compare.clear();
			Process.modals.start(true);
			$state.go('tab.process');
		});
	};

	$scope.$on('$ionicView.loaded', function(e, data) {
		initialize();
	})


	$scope.$on('PRODUCTS_CHANGED',function(event, uids){
		Definition.interface(vm.filters.definitions, uids);
		vm.uids = uids;
	});
}

export default controller;


// WEBPACK FOOTER //
// ./app/components/category/category.controller.js